import React from 'react';
import {i18n} from '@netx/core/i18n';
import {Avatar} from '@mui/material';
import {styled} from '@netx/core-components/Theme';
import Chip, {ChipProps} from '../Chip';

const CountChipRoot = styled(Chip)(({theme}) => ({
	flex: '0 0 auto',
}));

export interface CountChipProps
	extends Partial<
		Omit<ChipProps, 'avatar' | 'deleteIcon' | 'icon' | 'onDelete'>
	> {
	/**
	 * The count to display.
	 */
	count?: number;
	onClear?: () => void;
}

export const CountChipPrimitive = (
	{
		count,
		disabled,
		label,
		loading = false,
		variant = 'outlined',
		onClear,
		...props
	}: CountChipProps,
	ref: React.ForwardedRef<HTMLDivElement>,
) => {
	const _label = label != null && label != '' ? label : i18n.t('i18n.selected');
	return (
		<CountChipRoot
			ref={ref}
			deleteTabbable
			deleteTitle={`${i18n.t('i18n.clear')} ${_label}`}
			avatar={
				<Avatar>
					{loading || count == null ? '-' : count > 99 ? '99+' : count}
				</Avatar>
			}
			{...props}
			disabled={disabled || loading}
			label={_label}
			variant={variant}
			onDelete={!loading && !!count ? onClear : undefined}
		/>
	);
};

export const CountChip = React.forwardRef(CountChipPrimitive) as (
	props: CountChipProps,
) => JSX.Element;

export default CountChip;
